
import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";

/*export const fetchPortfolioInstruments = async () => {
    try {
        const res  = await fetch('/api/portfolio/fetch');
        const data = await res.json();
        return data;
    } catch (error) {
        console.error('Error fetching Portfolio instruments:', error);
        return [];
    }
};*/

/*export const fetchPortfolioInstruments = async () => {
    try {
        const res = await fetch('/api/portfolio/fetch');

        if (!res.ok) {
            console.error(`Backend error: ${res.status} ${res.statusText}`);
            return { transactions: [], quotes: [] };
        }

        // avoid "Unexpected end of JSON input"
        const text = await res.text();
        if (!text) {
            console.error("Backend returned empty response");
            return { transactions: [], quotes: [] };
        }

        return JSON.parse(text);

    } catch (error) {
        console.error('Error fetching Portfolio instruments:', error);
        return { transactions: [], quotes: [] };
    }
};*/

export const fetchPortfolioInstruments = async () => {
    const t0 = performance.now(); // ⏱️ start client timer

    try {
        const res = await fetch('/api/portfolio/fetch');

        const tFetchDone = performance.now(); // headers + body received
        console.log(
            `Client: fetch completed in ${(tFetchDone - t0).toFixed(1)} ms`
        );

        if (!res.ok) {
            console.error(`Backend error: ${res.status} ${res.statusText}`);
            return { transactions: [], quotes: [] };
        }

        const text = await res.text();

        const tTextDone = performance.now(); // body fully read
        console.log(
            `Client: response body read in ${(tTextDone - tFetchDone).toFixed(1)} ms`
        );

        if (!text) {
            console.error("Backend returned empty response");
            return { transactions: [], quotes: [] };
        }

        const data = JSON.parse(text);

        const tParseDone = performance.now(); // JSON parse done
        console.log(
            `Client: JSON.parse took ${(tParseDone - tTextDone).toFixed(1)} ms`
        );

        console.log(
            `Client: TOTAL time ${(tParseDone - t0).toFixed(1)} ms`
        );

        return data;

    } catch (error) {
        console.error('Error fetching Portfolio instruments:', error);
        console.log(
            `Client: TOTAL time ${(performance.now() - t0).toFixed(1)} ms (error path)`
        );
        return { transactions: [], quotes: [] };
    }
};



